<template>
  <section class="container-full-5">
    <h2 class="secondary-font mb-6">Prévisions</h2>
    <p class="text-grey-600">Vos prévisions budgétaires.</p>
    <div class="clear-both h-60" />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BudgetPrevisions'
})
</script>
